<ng-container *transloco="let t">
    <mat-card
        class="altair-card ip-addresses-card bg-white border-radius border-none d-block"
        [class.component-dark-theme]="themeService.isDark()"
    >
        @if (scan) {
        <mat-card-content>
            <h5 class="header-title mb-0">
                <span class="badge text-soft-info">{{ data.length }}</span>
                {{ t("ip-addresses") }}
            </h5>
            <small class="text-warning float-end">
                {{ t("ip-addresses-highlighted") }}
            </small>
            <br />
            @for (item of data; track item) { @if (item.is_cdn) {
            <span
                class="badge text-soft-warning info"
                data-toggle="tooltip"
                data-placement="top"
                title="{{ item.ports.length }} Ports Open."
            >
                {{ item.address }}
            </span>
            } @else {
            <span
                class="badge text-soft-info info"
                data-toggle="tooltip"
                data-placement="top"
                title="{{ item.ports.length }} Ports Open."
            >
                {{ item.address }}
            </span>
            } }
        </mat-card-content>
        }
    </mat-card>
</ng-container>
